import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, take } from 'rxjs';
import { ActorService } from '@shared/actor/actor.service';
import { Actor } from '@shared/actor/actor.model';

@Injectable({ providedIn: 'root' })
export class ActorResolver implements Resolve<Actor | null> {
  constructor(private actorService: ActorService) {
  }

  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<Actor|null> {
    return this.actorService.getUserInfo().pipe(take(1));
  }
}
